export default "__VITE_ASSET__CoMFE04B__"